import React from 'react';
import { useFreemium } from '../context/FreemiumContext';

// Card comercial de WhatsApp para docentes registrados que aún no tienen
// plan activo. Al hacer clic abre una conversación 1:1 con el número
// comercial con mensaje precargado del Plan Plataforma.
// Sólo aparece si el usuario NO tiene plan activo.
const WA_URL = 'https://wa.me/56998759833?text=Hola.%20Deseo%20contratar%20el%20Plan%20Plataforma%20Portafolio%20Digital%20Docente.';

export default function WhatsAppPremiumCard() {
    const { status } = useFreemium();
    // Ocultar cuando el usuario ya tiene cualquier plan activo (pagado y vigente).
    if (status?.plan_activo) return null;
    return (
        <a
            href={WA_URL}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Consultar por WhatsApp sobre el Plan Plataforma"
            data-testid="whatsapp-premium-card"
            className="group block w-full overflow-hidden rounded-xl border border-emerald-200 bg-gradient-to-br from-emerald-50 via-white to-emerald-50 p-4 shadow-sm transition-all hover:-translate-y-0.5 hover:border-emerald-400 hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:ring-offset-2"
        >
            <div className="flex items-start gap-3">
                <div className="grid h-11 w-11 shrink-0 place-items-center rounded-full bg-[#25D366] text-white shadow-sm ring-2 ring-white group-hover:scale-110 transition-transform">
                    <svg viewBox="0 0 24 24" className="h-6 w-6" fill="currentColor" aria-hidden="true">
                        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.966-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.15-.174.199-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
                    </svg>
                </div>
                <div className="min-w-0 flex-1">
                    <div className="flex flex-wrap items-baseline gap-x-2">
                        <div className="font-heading text-base font-bold text-slate-900">
                            💬 ¿Necesitas ayuda?
                        </div>
                        <div className="text-sm font-semibold text-emerald-700">
                            Consulta por WhatsApp
                        </div>
                    </div>
                    <p className="mt-0.5 text-xs text-slate-500">
                        Portafolio Docente 2026 · Plan Plataforma
                    </p>
                    <p className="mt-1.5 text-xs text-slate-600 leading-relaxed">
                        Habla con nuestro equipo por WhatsApp para conocer el
                        <strong> Plan Plataforma </strong>y resolver todas tus dudas
                        antes de activar tu acceso completo.
                    </p>
                </div>
                <div className="hidden sm:block shrink-0 self-center">
                    <span className="inline-flex items-center rounded-full bg-[#25D366] px-3 py-1.5 text-xs font-semibold text-white shadow-sm group-hover:bg-[#128C7E] transition-colors">
                        Abrir WhatsApp →
                    </span>
                </div>
            </div>
            {/* CTA mobile — visible sólo en móviles debajo del texto */}
            <div className="mt-3 sm:hidden">
                <span className="inline-flex w-full items-center justify-center rounded-full bg-[#25D366] px-3 py-2 text-xs font-semibold text-white shadow-sm">
                    Abrir WhatsApp →
                </span>
            </div>
        </a>
    );
}
